import { render, staticRenderFns } from "./DocumentModal.vue?vue&type=template&id=5b80f312&scoped=true&"
import script from "./DocumentModal.vue?vue&type=script&lang=js&"
export * from "./DocumentModal.vue?vue&type=script&lang=js&"
import style0 from "./DocumentModal.vue?vue&type=style&index=0&id=5b80f312&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b80f312",
  null
  
)

export default component.exports